import { render, staticRenderFns } from "./pointsMall.vue?vue&type=template&id=7cabbfe2&scoped=true&"
import script from "./pointsMall.vue?vue&type=script&lang=js&"
export * from "./pointsMall.vue?vue&type=script&lang=js&"
import style0 from "./pointsMall.vue?vue&type=style&index=0&id=7cabbfe2&prod&lang=scss&scoped=true&"
import style1 from "./pointsMall.vue?vue&type=style&index=1&id=7cabbfe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cabbfe2",
  null
  
)

export default component.exports